export default "<span *ngIf='!isSaving'>{{text}}</span>\n<div *ngIf='isSaving' class=\"loader\"></div>";